module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Sean McNeal strode into the bedroom of the suite, a cup of coffee balanced in one hand. He stood for a moment enjoying the sight of legislative assistant Tessa Janine Barton sleeping. She insisted on being called TJ, reasoning that Tessa was too sweet, and she didn’t consider herself sweet, although Sean disagreed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her chin-length sandy-blond hair spread out on the pillowcase in a semicircle and her cheeks were still flushed a rosy pink from making love into the small hours of the morning. The one thing he liked most about TJ was the intensity she applied to everything—her job, her politics and especially sex.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d known her only two weeks and, despite his vow to never let a woman sneak beneath the radar screen and clobber his defenses, he felt TJ had done just that. For the past few days Sean had been thinking dangerous thoughts of ever-after with one woman—a stream of consciousness he’d never swam up. TJ Barton with her athletic body, passion for life and ability to laugh just when you needed it most had slipped beneath his skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d fallen hard and rather than regret it, he woke each morning looking forward to seeing her face on the pillow beside him. What would happen when they returned to the States and resumed their mutually disparate lives? Would he go back to being the perpetually single bachelor, utterly devoted to his job and nothing else?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean didn’t want to think beyond today and TJ’s beautiful body lying naked beneath the sheets. Rather than go to work, he wanted to yank off the tie strangling his throat, crawl out of the business suit he felt so alien in and get naked with her. Maybe spend the day in bed, recapturing the magic of last night’s lovemaking.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unfortunately, he had a job to do and so did she. He leaned over her and pressed a kiss to the erogenous zone behind her ear—that sensitive spot that drove her crazy. “Wake up, sleepyhead.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ummmm.” She stretched, her lithe form outlined beneath the sheets. “What time is it?” Her voice was like soft gravel, a sexy whisper clouded with sleep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your meeting begins in twenty minutes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her body halted in mid-stretch and her eyes flew open. “What?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He really liked that her eyes were the deep brown of dark chocolate in stark contrast to her sandy-blond hair. “You have twenty minutes before you’re expected at the embassy.” He smacked her thigh. “Get up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why didn’t you wake me earlier?” She sat up, the sheet pooling around her waist, exposing the smooth skin and taut lines of her upper body and pert breasts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You looked so sexy, I hated to wake you. Besides, it’s only a block to the embassy. If you hurry, you’ll even have time for this cup of coffee.” Truth was he’d felt guilty for keeping her up making love until two in the morning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Haddock will be furious if I’m not there on time.” She flung the sheets aside and stood beside him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean smoothed a hand down her hip and pulled her against him. “I’m all for skipping our meetings and staying here.” Pressing a kiss to her lips, one hand slid up her back and the other down over her naked bottom.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ummm.” Her tongue delved between his lips and dueled with his; her hands slipped beneath his jacket to wrap around his waist. She squeezed him hard and leaned back. “As interesting as the possibility sounds, I have to be there. Congressman Haddock is ready to wrap up this meeting with Dindian Prime Minister Abediayi and get back to the States.” One more hard kiss and she pushed away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean sighed. Back to the States. Back to the real world of high-paced metro living, where people barely had time to think much less get to know each other. “Does he still plan to leave the day after tomorrow?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If he can, he’d like to leave sooner,” she said from the bathroom. “It all depends on the outcome of today’s meeting. What about you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My plans are fluid. I can come and go as I please, within reason.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Must be nice to be your own boss.” She strode back through the bedroom wearing a shell-pink bra and matching lace panties.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean resisted the urge to grab her and throw her on the bed. His business was her business, only he hadn’t filled her in on all the details. In his line of work, the less everyone knew about his real job, the better. The outer shell he’d constructed was enough for anyone to know, including TJ.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As far as TJ Barton and personnel at the embassy were concerned, he was a business consultant there to assist the small African nation of Dindi with their application for assistance from the U.S. government through the Millennium Challenge program. His covert duty as a Stealth Operations Specialist was ferreting out insider information on Dindi and on terrorist activities purportedly sponsored by their president’s opposing political party, or any other faction that could impact the congressman’s visit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He checked his watch. Marty Sikes expected him at the embassy in five minutes. “I need to go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("TJ zipped the back of her simple black skirt and padded over to him in bare feet. “Will I see you later?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He nodded, staring down into her shining brown eyes. “Can’t promise when.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Me either.” She stood on tiptoe and pressed a kiss to his lips. “I wish the day was already over.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Same here.” He returned the pressure, holding her close for only a moment more before he let go. The day ahead already seemed too long and he wasn’t sure he liked feeling anxious to get through it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sean?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pausing at the door, he turned toward her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This has been crazy, these last two weeks.” One hand pushed her hair behind her ear, a habit she only displayed when she was nervous.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Absolutely.” Sean’s gut knotted. He’d enjoyed the last two weeks, but was he ready to admit it meant more than just a fling?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She smiled, her face lighting the room. “I’ve had fun.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His belly flipped over that smile. “Same here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her lips straightened and her brow furrowed in that way he knew meant she was about to say something that meant a lot to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Recognizing and reading body language were all part of Sean’s job. Sometimes he wished he wasn’t so good at it. He found himself praying she wouldn’t say anything declaratory, especially the L word. He’d never experienced love and he wasn’t convinced it really existed. Even when he was a boy, that emotion was illusive. The only child of an alcoholic father, he hadn’t known real affection. And his mother had split when he was barely five.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nor was he certain he wanted the debilitating limitations involved with being in love. He’d watched his pal Marty go from a totally focused, leap-into-action S.O.S. agent to one who stopped to consider all his actions carefully before pursuing the one most reasonable and least life-threatening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("TJ pushed the hair behind her other ear. “When we go back to Washington—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With his heart pounding against his ribs, Sean felt the sudden need to breathe open, fresh air, even in the smelly streets of Conbanau. He jerked the door open and said over his shoulder, “Let’s cross that bridge when we get to it.” And then he escaped like his life depended on it.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HEN THE DOOR SLAMMED")])]), _vm._v(" behind Sean, TJ shook her head. Okay, the guy wasn’t ready for anything more than a fling. She’d suspected that was the case when he refused to open up about his past, his work or anything personal. Oh, he’d shared information about his favorite sports team and the foods he most enjoyed. But who was the real Sean McNeal? What made him tick? And why did he run when she’d only tried to mention a future beyond the two weeks they’d spent in Africa? She wouldn’t ask for marriage or false promises. Heck, she hadn’t even finished her sentence before he bolted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She slipped her arms into the black silk jacket, glad of its lightweight fabric. The heat and humidity of the colorful coastal city of Conbanau could be oppressive as the day wore on. And today promised to be a very wearing day.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The thought that would get her through the long, boring meetings with the pompous prime minister and his mealymouthed financial aide was the knowledge that Sean would be somewhere in the embassy with her. And, if she hadn’t scared him off, he’d be back in her room that night.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her body tingled in anticipation and she peered out the window, catching sight of Sean crossing the busy street, dodging buses and brightly dressed men and women walking or riding bicycles. As he wove through the crowded streets to the embassy only a block away, his white skin and dark suit stood out in the sea of humanity. He wore his hair longer than most men, giving him a more daring look. The man was tall, dark, sexy and mysterious, making him everything she ever dreamed of, yet didn’t have room for, in her life as a legislative assistant.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she hadn’t come to Dindi ahead of Congressman Haddock, she probably would never have met Sean at the little café between the hotel and the embassy. They would never have strolled along the beach at sunset talking about the stars and constellations. And they never would have captured the moonlight in that single, soul-defining kiss that launched them into a night of lovemaking unsurpassed by anything TJ had ever experienced.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She sighed, something she’d done a lot of in the past week. What was wrong with her? Her life was just as she loved it—fast-paced, exciting and purposeful. As a legislative assistant, she had more influence on government decisions than the average American. Since she’d left the FBI, she’d mentored with Mason Haddock, Republican congressman from the great state of Texas. Her work was safe, fascinating and everything she wanted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Until Sean showed up. He was the icing on the cake. A businessman, not an FBI agent on a dangerous assignment. TJ liked that Sean wasn’t in a career where dodging bullets was just another hazard of the job. She’d suffered through a relationship like that before and wanted nothing to do with danger and life-threatening situations. Give her safety and stability every day. She didn’t miss the late-night stakeouts, being shot at by cornered criminals or waiting by the phone to hear if the man she thought she loved was dead or alive after a particularly dangerous assignment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Granted, life as an FBI agent wasn’t all shoot-outs and gunfire. They spent most of their time interviewing and digging through mounds of paperwork searching for clues. But all it took was one bullet, one bomb, one strung out junkie to ruin your day—or end a man’s life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No, sir. Give her a quiet government job where she could help shape decisions through intelligence instead of brute force. Although, sometimes she wanted to resort to brute force when the congressman was particularly stubborn on certain issues.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A quick glance at her watch made TJ gasp. Crud! Congressman Haddock would be furious if she wasn’t there a full hour before the proposed meeting. Which gave her exactly four minutes to find her shoes and join the sea of people on the streets heading in the same direction as Sean.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dashing back through the suite, she slipped into her serviceable black pumps, grabbed her briefcase and raced down the wide staircase of the five-star hotel. Atypical for the large African center of commerce, the streets were filled with people of all classes of society, each with a purpose for the day.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("TJ’s purpose was to get to the embassy in—she checked her watch—three minutes. Half walking and half running, she hurried down the long block toward the three-story, forty-five-room, sprawling U.S. embassy surrounded by an impressive wrought-iron fence and lush green lawns. She could see the building above the heads of the people surrounding her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With his head start on her, Sean should be clearing the gate about now. She wished she’d woken when he had so that they could walk together and so she wouldn’t be so winded when she arrived. As a legislative assistant, she prided herself in always being calm and collected. It was her job to make Congressman Haddock look good by being prepared and ready for anything and everything. Meeting Sean had thrown her into reactionary mode, constantly running to keep up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she neared the imposing building, the throng of people thinned. With the path clear, she was in the homestretch and should make it there only a few minutes after the congressman. TJ slowed short of the gate and dug in her purse for her passport and identification. When she found them she moved forward without looking up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She bumped into a businessman leaving the gate at the same time as she approached. Her impression of the man was dark hair, intense brown eyes and an expensive pinstripe suit. TJ apologized for her clumsiness, but the businessman didn’t even acknowledge her. He kept walking, his long strides eating the distance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Must be in a hurry.” TJ showed her passport and government identification badge to the Marine standing guard. While she tucked the items back in her purse, Congressman Haddock’s empty black limousine exited the compound. Great, he’d already arrived and was probably looking for her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Slinging her purse back over her shoulder she’d taken two steps across the long, cobblestone drive when an explosion ripped through the air, knocking her off her feet and spewing stone, dust and debris across the green lawns.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The spacious white building with elegant arches crumbled before her eyes, the center collapsing into a pile of rubble. A cloud of black smoke and brown dust rose into the air, billowing out from the center of the blast.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("TJ tried to sit up, but when she did, her ears rang and the scene before her spun out of control. Bending forward, she tucked her head between her knees, fighting for control of her senses and the contents of her stomach. When she managed to raise her head, her vision blurred, dust filled her lungs and she erupted in a burst of coughing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Men and women ran toward a jumble of crumbled stone, jagged timbers and broken glass where the American embassy had once stood. People scrambled around the debris, but nothing moved beneath the destruction. Those who’d been inside couldn’t have survived the blast.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Sean.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As the screech of sirens moved closer, a woman’s wail rose above the noise. The sound emerged from deep in TJ’s chest. She swayed, welcoming the black abyss dragging her into darkness.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0779a04d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blownaway_ch01.vue
// module id = 66
// module chunks = 0